/**
 * Copies text to clipboard using modern clipboard API if available, otherwise falls back to execCommand method
 * @param text - The text to copy
 * @returns Promise resolving to boolean indicating success
 */
export const copyToClipboard = async (text: string): Promise<boolean> => {
  // Try modern clipboard API first
  if (window.location.protocol === 'https:' || window.location.hostname === 'localhost') {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch {
      // Fall back to execCommand method
    }
  }

  // Fallback method for non-secure origins or if clipboard API fails
  try {
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.position = 'fixed'
    textArea.style.left = '-999999px'
    textArea.style.top = '-999999px'
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    const success = document.execCommand('copy')
    document.body.removeChild(textArea)
    return success
  } catch (_err) {
    return false
  }
}
